import { render, staticRenderFns } from "./AuditionDetail.vue?vue&type=template&id=166f5f35&"
import script from "./AuditionDetail.vue?vue&type=script&lang=js&"
export * from "./AuditionDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuditionDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports